import { WidgetsRenderer } from "components/WidgetsRenderer";
import { usePageData } from "shared/contexts/PageData";

export const FooterWidgets = () => {
  const { footer } = usePageData();

  return <WidgetsRenderer registry="footer" items={footer} />;
};
